import { connect } from 'react-redux';
import { IAppState } from '../../../../common/state';
import { DevelopersContacts } from './index';

const DevelopersContactsContainer = connect((state: IAppState) => ({
  newbuildingInfo: state.results.newbuildingInfo,
  geo: state.filters.jsonQuery.geo,
  userGADataLayerData: state.userGADataLayerData,
  jsonQuery: state.results.jsonQuery,
  user: state.user,
  results: state.results,
}))(DevelopersContacts);

// tslint:disable-next-line:no-default-export
export default DevelopersContactsContainer;
